import { render, staticRenderFns } from "./TopStatistic.vue?vue&type=template&id=9a2b4e86&scoped=true"
import script from "./TopStatistic.vue?vue&type=script&lang=js"
export * from "./TopStatistic.vue?vue&type=script&lang=js"
import style0 from "./TopStatistic.vue?vue&type=style&index=0&id=9a2b4e86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2b4e86",
  null
  
)

export default component.exports